import SignatoryRepository from "../domain/data/SignatoryRepository";
import Signatory, { SignatoryLogin } from "../domain/entities/Signatory";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APISignatoryRepository implements SignatoryRepository {
  private client = new AwsApiClient();

  async saveSignatory(signatory: Signatory): Promise<Signatory> {
    try { 
      const response = await this.client.post(`/api/signatory`, signatory);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async saveLanguageSignatory(language: string, signatoryEmail: string): Promise<Signatory> {
    try {
      const encodedSignatoryEmail = encodeURIComponent(signatoryEmail);
      const response = await this.client.postExternal(`/api/signatory/language/${encodedSignatoryEmail}`, 
        {preferredLanguage: language}, "none"
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  searchSignatory(user: User, email: string): Promise<Signatory | undefined> {
    throw new Error("Method not implemented.");
  }
  searchSignatories(user: User, term: string): Promise<Signatory[]> {
    throw new Error("Method not implemented.");
  }
  login(
    username: string,
    password: string
  ): Promise<{ signatory: Signatory; signatures: string[] } | undefined> {
    throw new Error("Method not implemented.");
  }
  requestPasswordUpdate(email: string): Promise<boolean> {
    throw new Error("Method not implemented.");
  }
  passwordUpdate(
    username: string,
    password: string,
    otp: string
  ): Promise<Signatory | undefined> {
    throw new Error("Method not implemented.");
  }
  async getSignatoryByShortId(shortid: string): Promise<Signatory> {
    try {
      const response = await this.client.getExternal(
        `/api/ext/signatory/${shortid}`
      );
      //do the pw/pin check here...
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getSignatoryByShortIdThenVerify(shortId: string, password: string): Promise<SignatoryLogin> {
    console.log("GET API: "+shortId);
    try { 
        // Encode string as Uint8Array (required for crypto.subtle)
        const encoder = new TextEncoder();
        const data = encoder.encode(password);

        // Compute SHA-256 hash
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);

        // Convert hash buffer to hex string
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hexString = hashArray.map(byte => byte.toString(16).padStart(2, "0")).join(""); 
        const response = await this.client.getExternal(
        `/api/ext/signatory/${shortId}/${hexString}`
      ); 
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    } 
  }

  async getSignatoryByEmail(email: string): Promise<Signatory> {
    try {
      const response = await this.client.getExternal(`/api/signatory/${email}`);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async sendNewPin(shortId: string, forceResend?: boolean, email?: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      if (forceResend) params.append('resend', 'true');
      if (email) params.append('email', email);
      const query = params.toString();
      const url = `/api/ext/signatory/pin/${shortId}${query ? `?${query}` : ''}`;
      const response = await this.client.getExternal(url);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
